import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { VInput, VModal } from '@/package';

const CollectionNewFolderModal = ({
  visible,
  onNewFolder,
  onUpdateVisible,
}: {
  visible: boolean;
  onNewFolder(name: string): void;
  onUpdateVisible(visible: boolean): void;
}) => {
  const [newDirectoryName, setNewDirectoryName] = useState('');
  const { t } = useTranslation();

  return (
    <VModal
      visible={visible}
      footer={{
        cancelText: t('modal.cancelButtonText.intimidate'),
        confirmText: t('modal.confirmButtonText.vanilla'),
      }}
      title={t('storage.createNewFolderButtonText.varietism')}
      size="small"
      onUpdateVisible={onUpdateVisible}
      onHide={e => {
        if (e.trigger === 'confirm' && !newDirectoryName) {
          e.preventDefault();
          return;
        }

        onNewFolder(newDirectoryName);
        setNewDirectoryName('');
      }}
    >
      <VInput
        value={newDirectoryName}
        autoFocus
        fluid
        onChange={e => setNewDirectoryName(e.target.value)}
      />
    </VModal>
  );
};

export default CollectionNewFolderModal;
